<!-- 场所及设备情况表 -->

<template>
  <div class="tabCage table6E">
    <div class="tabTtl">
      <span v-if="pressType == 1">表 1-6：重点音像制品情况登记表</span>
      <span v-else>表 1-6：重点电子出版物情况登记表</span>
    </div>
    <div class="editArea">
      <el-form ref="paramCk" :model="params" :rules="rules">
        <table>
          <tr>
            <td class="edName">出版物名称：</td>
            <td class="edInpBig">
              <el-form-item prop="proName" :inline-message="true">
                <el-input v-model="params.proName" size="small" placeholder="请输入项目名称"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">重点项目名称：</td>
            <td class="edInp edSelect">
              <el-form-item prop="importantProName" :inline-message="true">
                <el-select v-model="params.importantProName" size="small" placeholder="请选择重点项目名称">
                  <el-option v-for="item in dicDats['C021']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="dicMap['C021'][params.importantProName] == '其他'"
                prop="importantProNameOther"
                :inline-message="true">
                <el-input v-model="params.importantProNameOther" size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">级别：</td>
            <td class="edInp edSelect">
              <el-form-item prop="hjLevel" :inline-message="true">
                <el-select v-model="params.hjLevel" size="small" placeholder="请选择级别">
                  <el-option v-for="item in dicDats['C024']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="dicMap['C024'][params.hjLevel] == '其他'" prop="hjLevelOther" :inline-message="true">
                <el-input v-model="params.hjLevelOther" size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">拟定完成时间：</td>
            <td class="edInp">
              <el-form-item prop="ydDate" :inline-message="true">
                <el-date-picker
                  v-model="params.ydDate"
                  align="right"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">备注：</td>
            <td class="edInpTextArea">
              <el-form-item prop="remark" :inline-message="true">
                <el-input :rows="3" type="textarea" v-model="params.remark" size="small"></el-input>
              </el-form-item>
              <!-- <el-input :rows="5" type="textarea" v-model="params.remark" size="small"></el-input> -->
            </td>
          </tr>
        </table>
      </el-form>
    </div>
    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="pubStatus == 0" type="primary" @click="editSave('paramCk')" size="small">保存</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt6";
import { tabUpdate6, tabRead6 } from "@/api/pressRole/pressRole";
export default {
  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      pressType: this.$route.query.pressType,
      dicDats: {},
      submiting: false,
      dicMap: {
        C021: {},
        C024: {},
      },
      pubStatus: 0,
    };
  },
  methods: {
    editSave: function (name) {
      let that = this;
      this.$refs[name].validate((valid) => {
        this.params.publishId = this.$route.query.pressId;
        this.params.publishMaterialId = this.$route.query.mtId;
        if (valid) {
          tabUpdate6({
            // pimportantproducts: this.params
            // 模组化
            data: this.params,
            // 身份验证要用
            publishMaterialId: this.params.publishMaterialId,
          })
            .then((response) => {
              let tipCode = response.payload.pimportantproducts.code;
              let tipMessage = response.payload.pimportantproducts.message;

              that.submiting = false;
              if (tipCode == -1) {
                that.$message.error(`保存错误: ${tipMessage}`);
                return;
              }
              this.$message({
                message: "保存成功！",
                type: "success",
              });

              this.goBack();
            })
            .catch((error) => {
              this.submiting = false;
            });
        } else {
          return false;
        }
      });
    },

    tabReEdit: function () {
      tabRead6({ id: this.$route.query.id }).then((response) => {
        this.params = response.pimportantproducts;
      });
    },

    dictInit: function () {
      let nameArr = ["C021", "C024"];
      let newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then((result) => {
        this.dicDats = result;
        this.dicMap["C021"] = this.$store.getters.dictionary["C021"];
        this.dicMap["C024"] = this.$store.getters.dictionary["C024"];
      });
    },

    goBack: function () {
      this.$router.go(-1);
      // this.$router.push({
      //      path:'view_tab6',
      //      query:{
      //          pressId:this.$route.query.pressId,
      //          mtId:this.$route.query.mtId,
      //          pressType:this.$route.query.pressType,
      //      }
      //  });
    },
  },

  created: function () {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table6E .edInp .el-textarea {
  width: 450px;
}

.table6E .edSelect .el-form-item {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// table6.vue?6b80d00d